'use strict';

angular.module( 'template/timepicker/timepicker.html', [ ] ).run( [ '$templateCache', function ( $templateCache ) {
	$templateCache.put( 'template/timepicker/timepicker.html',
		'<table>\n'
		+ '	<tbody>\n'
		+ '		<tr class="text-center time-picker-mobile">\n'
		+ '			<td><a ng-click="incrementHours()" class="btn btn-link"><span class="icon2-up-arrow"></span></a></td>\n'
		+ '			<td>&nbsp;</td>\n'
		+ '			<td><a ng-click="incrementMinutes()" class="btn btn-link"><span class="icon2-up-arrow"></span></a></td>\n'
		+ '			<td ng-show="showMeridian"></td>\n'
		+ '		</tr>\n'
		+ '		<tr>\n'
		+ '			<td style="width:50px;" class="form-group" ng-class="{ \'has-error\' : invalidHours && isStart}">\n'
		+ '				<div class="input-group"> \n'
		+ '					<input type="text" ng-model="hours" ng-change="updateHours()" class="form-control text-center" ng-mousewheel="incrementHours()" ng-readonly="readonlyInput" maxlength="2" ng-focus="true">\n'
		+ '                   <span class="input-group-addon">\n'
		+ '						<span class="icon2-up-arrow" ng-click="incrementHours()"> </span>\n'
		+ '						<span class="icon2-down-arrow" ng-click="decrementHours()"> </span>\n'
		+ '					</span>\n'
		+ '               </div>\n'
		+ '			</td>\n'
		+ '			<td>:</td>\n'
		+ '			<td style="width:50px;" class="form-group" ng-class="{ \'has-error\' : invalidMinutes && isStart}">\n'
		+ '				<div class="input-group"> \n'
		+ '					<input type="text" ng-model="minutes" ng-change="updateMinutes()" class="form-control text-center" ng-readonly="readonlyInput" maxlength="2">\n'
		+ '                   <span class="input-group-addon">\n'
		+ '						<span class="icon2-up-arrow" ng-click="incrementMinutes()"> </span>\n'
		+ '						<span class="icon2-down-arrow" ng-click="decrementMinutes()"> </span>\n'
		+ '					</span>\n'
		+ '               </div>\n'
		+ '			</td>\n'
		+ '			<td class="meridian" ng-show="showMeridian"><button type="button" class="btn btn-default text-center" ng-click="toggleMeridian()">{{meridian}}<span ng-hide="meridian">AM</span></button></td>\n'
		+ '		</tr>\n'
		+ '		<tr class="text-center time-picker-mobile">\n'
		+ '			<td><a ng-click="decrementHours()" class="btn btn-link"><span class="icon2-down-arrow"></span></a></td>\n'
		+ '			<td>&nbsp;</td>\n'
		+ '			<td><a ng-click="decrementMinutes()" class="btn btn-link"><span class="icon2-down-arrow"></span></a></td>\n'
		+ '			<td ng-show="showMeridian"></td>\n'
		+ '		</tr>\n'
		+ '	</tbody>\n'
		+ '</table>\n'.toString()
	);
} ] );

angular.module( 'template/datepicker/day.html', [ ] ).run( [ '$templateCache', function ( $templateCache ) {
	$templateCache.put( 'template/datepicker/day.html',
		'<table role="grid" aria-labelledby="{{uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n'
		+ '  <thead>\n'
		+ '    <tr>\n'
		+ '      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="icon2-left-arrow"></i></button></th>\n'
		+ '      <th colspan="{{5 + showWeeks}}"><button id="{{uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n'
		+ '      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="icon2-right-arrow"></i></button></th>\n'
		+ '    </tr>\n'
		+ '    <tr>\n'
		+ '      <th ng-show="showWeeks" class="text-center"></th>\n'
		+ '      <th ng-repeat="label in labels track by $index" class="text-center"><small aria-label="{{label.full}}">{{label.abbr}}</small></th>\n'
		+ '    </tr>\n'
		+ '  </thead>\n'
		+ '  <tbody>\n'
		+ '    <tr ng-repeat="row in rows track by $index">\n'
		+ '      <td ng-show="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n'
		+ '      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{dt.uid}}" aria-disabled="{{!!dt.disabled}}">\n'
		+ '        <button type="button" style="width:100%;" class="btn btn-default btn-sm" ng-class="{\'btn-info\' : dt.selected }" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="{ \'text-muted\' : dt.secondary, \'text-info\' : dt.current}">{{dt.label}}</span></button>\n'
		+ '      </td>\n'
		+ '    </tr>\n'
		+ '  </tbody>\n'
		+ '</table>\n'.toString()
	);
} ] );

angular.module( 'template/datepicker/month.html', [ ] ).run( [ '$templateCache', function ( $templateCache ) {
	$templateCache.put( 'template/datepicker/month.html',
		'<table role="grid" aria-labelledby="{{uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n'
		+ '  <thead>\n'
		+ '    <tr>\n'
		+ '      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="icon2-left-arrow"></i></button></th>\n'
		+ '      <th><button id="{{uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n'
		+ '      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="icon2-right-arrow"></i></button></th>\n'
		+ '    </tr>\n'
		+ '  </thead>\n'
		+ '  <tbody>\n'
		+ '    <tr ng-repeat="row in rows track by $index">\n'
		+ '      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{dt.uid}}" aria-disabled="{{!!dt.disabled}}">\n'
		+ '        <button type="button" style="width:100%;" class="btn btn-default" ng-class="{ \'btn-info\' : dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="{ \'text-info\' : dt.current}">{{dt.label}}</span></button>\n'
		+ '      </td>\n'
		+ '    </tr>\n'
		+ '  </tbody>\n'
		+ '</table>\n'.toString()
	);
} ] );

angular.module( 'template/datepicker/year.html', [ ] ).run( [ '$templateCache', function ( $templateCache ) {
	$templateCache.put( 'template/datepicker/year.html',
		'<table role="grid" aria-labelledby="{{uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n'
		+ '  <thead>\n'
		+ '    <tr>\n'
		+ '      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="icon2-left-arrow"></i></button></th>\n'
		+ '      <th colspan="3"><button id="{{uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n'
		+ '      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="icon2-right-arrow"></i></button></th>\n'
		+ '    </tr>\n'
		+ '  </thead>\n'
		+ '  <tbody>\n'
		+ '    <tr ng-repeat="row in rows track by $index">\n'
		+ '      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{dt.uid}}" aria-disabled="{{!!dt.disabled}}">\n'
		+ '        <button type="button" style="width:100%;" class="btn btn-default" ng-class="{ \'btn-info\' : dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="{ \'text-info\' : dt.current}">{{dt.label}}</span></button>\n'
		+ '      </td>\n'
		+ '    </tr>\n'
		+ '  </tbody>\n'
		+ '</table>\n'.toString()
	);
} ] );

angular.module( 'mwl.calendar' ).run( [ '$templateCache', function ( $templateCache ) {
	$templateCache.put( 'src/templates/calendarMonthView.html',
		'<div class="cal-row-fluid cal-row-head">\n'

		+ ' <div class="cal-cell1" ng-repeat="day in vm.weekDays track by $index" ng-bind="day"></div>\n'

		+ '</div>\n'

		+ '<div class="cal-month-box">\n'

		+ ' <div ng-repeat="rowOffset in vm.monthOffsets track by rowOffset">\n'
		+ '   <div class="cal-row-fluid cal-before-eventlist">\n'
		+ '     <div\n'
		+ '       ng-repeat="day in vm.view | calendarLimitTo:7:rowOffset track by $index"\n'
		+ '       ng-init="dayIndex = vm.view.indexOf(day)"\n'
		+ '       class="cal-cell1 cal-cell {{ day.highlightClass }} month-day-calendar"\n'
		+ '       ng-click="vm.clickedDate = day.date;"\n'
		+ '       date="vm.clickedDate">\n'
		+ '       <div ng-include="\'src/templates/calendarMonthDay.html\'"></div>\n'
		+ '     </div>\n'
		+ '   </div>\n'

		+ '   <!-- Custom Slidebox -->\n'
		+ '   <div class="calendar-week-bottom">\n'
		+ '   </div>\n'
		+ ' </div>\n'
		+ '   <!-- Custom Slidebox -->\n'
		+ '   <calendar-slidebox ng-repeat="rowOffset in vm.monthOffsets track by rowOffset"\n'
		+ '     date-clicked="vm.clickedDate"\n'
		+ '     is-open="vm.openRowIndex === $index && vm.view[vm.openDayIndex].events.length > 0"\n'
		+ '     events="vm.view[vm.openDayIndex].events"\n'
		+ '     on-event-click="onEventClick"\n'
		+ '     edit-event-html="editEventHtml"\n'
		+ '     on-edit-event-click="onEditEventClick"\n'
		+ '     delete-event-html="deleteEventHtml"\n'
		+ '     on-delete-event-click="onDeleteEventClick">\n'
		+ '   </calendar-slidebox>\n'
		+ '</div>\n'.toString()
	);

	$templateCache.put( 'src/templates/calendarMonthDay.html',
		'<div tooltip= "{{vm.dayEvents[day.label]}}"\n'
		+ ' class="cal-month-day"\n'
		+ ' ng-class="{\n'
		+ '   \'cal-day-outmonth\' : !day.inMonth,\n'
		+ '   \'cal-day-inmonth\'  : day.inMonth,\n'
		+ '   \'cal-day-weekend\'  : day.isWeekend,\n'
		+ '   \'cal-day-past\'     : day.isPast,\n'
		+ '   \'cal-day-today\'    : day.isToday,\n'
		+ '   \'cal-day-future\'   : day.isFuture,\n'
		+ '   \'cal-day-active\'   : dayIndex === vm.openDayIndex && !day.isToday\n'
		+ ' }">\n'
		+ ' <small\n'
		+ ' ng-if="vm.dayEvents[day.date]>0"\n'
		+ '   class="cal-events-num badge badge-important pull-left"\n'
		+ '   ng-show="day.badgeTotal > 0"\n'
		+ '   ng-click="vm.dayClicked(day)"\n'
		+ '   ng-class="{pointer: day.events.length > 0}"\n'
		+ '   ng-bind="day.badgeTotal">\n'
		+ ' </small>\n'
		+ ' <span\n'
		+ '   class="pull-right"\n'
		+ '   data-cal-date\n'
		+ '   ng-bind="day.label">\n'
		+ ' </span>\n'
		+ ' <div ng-click="vm.dayClicked(day); $event.stopPropagation();" ng-include="\'src/templates/calendarMonthEventsList.html\'"></div>\n'
		+ '</div>\n'.toString()
	);

	$templateCache.put( 'src/templates/calendarMonthEventsList.html',
		'<div class="events-list" ng-show="day.events.length > 0" ng-init="vm.dayEvents[day.date]=0" >\n'
		+ ' <a\n'
		+ '   href="javascript:;"\n'
		+ '   ng-repeat="event in day.events track by $index" tooltip="{{$index}}"\n'
		+ '   ng-if="(event.startsAt | date:\'d\') == day.label"\n'
		+ '   class="pull-left event event-dot"\n'
		+ '   ng-class="{ \'event-info\' : !day.isToday }"\n'
		+ '   ng-init="vm.dayEvents[day.date]=1;event.endsAt = event.startsAt" \n'
		+ '   ng-mouseenter="vm.highlightEvent(event, true)"\n'
		+ '   ng-mouseleave="vm.highlightEvent(event, false)">\n'
		+ ' </a>\n'
		+ '</div>\n'.toString()
	);

	$templateCache.put( 'src/templates/calendar.html',
		'<div class="cal-context" ng-switch="view">\n'

		+ ' <div class="alert alert-danger" ng-switch-default>The value passed to the view attribute of the schedule is not set</div>\n'
		+ ' <div class="alert alert-danger" ng-hide="currentDay">The value passed to current-day attribute of the schedule is not set</div>\n'

		+ ' <mwl-calendar-year\n'
		+ '   events="events"\n'
		+ '   current-day="currentDay"\n'
		+ '   on-event-click="onEventClick"\n'
		+ '   on-edit-event-click="onEditEventClick"\n'
		+ '   on-delete-event-click="onDeleteEventClick"\n'
		+ '   on-timespan-click="onTimespanClick"\n'
		+ '   edit-event-html="editEventHtml"\n'
		+ '   delete-event-html="deleteEventHtml"\n'
		+ '   auto-open="autoOpen"\n'
		+ '   ng-switch-when="year"\n'
		+ ' ></mwl-calendar-year>\n'

		+ ' <mwl-calendar-month\n'
		+ '   events="events"\n'
		+ '   current-day="currentDay"\n'
		+ '   on-event-click="onEventClick"\n'
		+ '   on-edit-event-click="onEditEventClick"\n'
		+ '   on-delete-event-click="onDeleteEventClick"\n'
		+ '   on-timespan-click="onTimespanClick"\n'
		+ '   edit-event-html="editEventHtml"\n'
		+ '   delete-event-html="deleteEventHtml"\n'
		+ '   auto-open="autoOpen"\n'
		+ '   ng-switch-when="month"\n'
		+ '   ></mwl-calendar-month>\n'

		+ ' <calendar-week\n'
		+ '   events="events"\n'
		+ '   current-day="currentDay"\n'
		+ '   on-event-click="onEventClick"\n'
		+ '   on-edit-event-click="onEditEventClick"\n'
		+ '   on-delete-event-click="onDeleteEventClick"\n'
		+ '   edit-event-html="editEventHtml"\n'
		+ '   delete-event-html="deleteEventHtml"\n'
		+ '   ng-switch-when="week"\n'
		+ '   ></calendar-week>\n'

		+ ' <calendar-day\n'
		+ '  events="events"\n'
		+ '   current-day="currentDay"\n'
		+ '   on-event-click="onEventClick"\n'
		+ '   on-edit-event-click="onEditEventClick"\n'
		+ '   on-delete-event-click="onDeleteEventClick"\n'
		+ '   edit-event-html="editEventHtml"\n'
		+ '   delete-event-html="deleteEventHtml"\n'
		+ '   day-view-start="dayViewStart"\n'
		+ '   day-view-end="dayViewEnd"\n'
		+ '   day-view-split="dayViewSplit || 30"\n'
		+ '   ng-switch-when="day"\n'
		+ '   ></calendar-day>\n'
		+ '</div>\n'.toString()
	);
} ] );
